import { SubmissionError } from 'redux-form';

/**
 * form validation
 * @param error
 * @param name
 * @param message
 * @return void
 */
const validate = ({ error, name, message }) => {
  if (error) {
    throw new SubmissionError({
      [name]: message,
    });
  }
};

/**
 * montage form validation
 * @param {*} values
 */
export const validateMontage = (values) => {
  validate({
    error: !values.template,
    name: 'template',
    message: 'Template required',
  });
};

/**
 * theme form validation
 * @param {*} values
 */
export const validateTheme = (values) => {
  validate({
    error: !values.name,
    name: 'name',
    message: 'Name required',
  });
};

/**
 * theme form validation
 * @param {*} values
 */
export const validateTemplateLayer = (layer) => {
  if (layer.imageFile) {
    validate({
      error: !['image/png', 'image/jpeg'].includes(layer.imageFile.type),
      name: 'imageFile',
      message: 'Only png and jpg are accepted',
    });
  }
};

/**
 * background form validation
 * @param {*} values
 */
export const validateBackground = (values) => {
  validate({
    error: !values.title,
    name: 'title',
    message: 'Title required',
  });

  validate({
    error: !values.description,
    name: 'description',
    message: 'Description required',
  });
};

/**
 * decoration form validation
 * @param {*} values
 */
export const validateDecoration = (values) => {
  validate({
    error: !values.title,
    name: 'title',
    message: 'Title required',
  });

  validate({
    error: !values.image,
    name: 'image',
    message: 'Image required',
  });
};

/**
 * overlay form validation
 *
 * @param {*} values
 */
export const validateOverlay = (values) => {
  validate({
    error: !values.name,
    name: 'name',
    message: 'Name required',
  });

  validate({
    error: !values.description,
    name: 'description',
    message: 'Description required',
  });
};

/**
 * pack form validation
 * @param {*} values
 */
export const validatePack = (values) => {
  validate({
    error: !values.name?.trim(),
    name: 'name',
    message: 'Nom obligatoire',
  });
};
